
// import { Pagination, Box, useTheme } from '@mui/material';
// import { tokens } from '../../theme/theme';


// const CustomPagination = ({
//   pageCount,
//   currentPage,
//   onPageChange,
//   size = "medium",
//   color = "primary",
//   variant = "outlined",
//   shape = "rounded",
// }) => {
//     const theme = useTheme();
//     const colors = tokens(theme.palette.mode);
//   return (
//     <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>     
//       <Pagination
//         count={pageCount}
//         page={currentPage}
//         onChange={onPageChange}
//         size={size}
//         color={color}
//         variant={variant}
//         shape={shape}
//         showFirstButton
//         showLastButton
//         siblingCount={1}
//         boundaryCount={1}
//         sx={{
//             '& .MuiPaginationItem-root': {
//               fontWeight: 500,
//               borderRadius: '12px',
//               borderColor: colors.primary?.main || '#1976d2',
//               '&.Mui-selected': {
//                 backgroundColor: colors.primary?.main || '#1976d2',
//                 color: '#fff',
//                 '&:hover': {
//                   backgroundColor: colors.primary?.dark || '#1565c0',
//                 },
//               },
//             },
//           }}
//       />
//       </Box>
    
//   );
// };

// export default CustomPagination;


import { Pagination, Box, useTheme, alpha } from '@mui/material';
import { tokens } from '../../theme/theme';

const CustomPagination = ({
  pageCount,
  currentPage,
  onPageChange,
  size = "small",
  color = "primary",
  variant = "outlined",
  shape = "rounded",
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box 
      display="flex" 
      justifyContent="flex-end" 
      sx={{ 
        mt: 1.5, 
        py: 1,
        px: 1,
        backgroundColor: alpha(colors.grey[900], 0.3),
        borderRadius: 1.5,
        border: `1px solid ${alpha(colors.primary[400], 0.2)}`,
      }}
    >       
      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={onPageChange}
        size={size}
        color="primary"
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
        sx={{
          '& .MuiPaginationItem-root': {
            minWidth: '36px',
            height: '36px',
            fontSize: '0.75rem',
            fontWeight: 600,
            lineHeight: 1.2,
            borderRadius: '10px',
            border: `1px solid ${alpha(colors.primary[400], 0.4)}`,
            color: colors.grey[200],
            margin: '0 1px',
            padding: '0 4px',
            transition: 'all 0.2s ease',
            
            '&:hover': {
              backgroundColor: alpha(colors.primary[400], 0.15),
              borderColor: colors.primary[400],
              transform: 'translateY(-1px)',
              color: colors.primary[300],
            },
            '&.Mui-selected': {
              background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[500]} 100%)`,
              borderColor: colors.primary[500],
              color: '#fff',
              boxShadow: `0 4px 12px ${alpha(colors.primary[500], 0.4)}`,
              '&:hover': {
                background: `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.primary[600]} 100%)`,
                transform: 'translateY(-1px)',
                boxShadow: `0 6px 16px ${alpha(colors.primary[500], 0.5)}`,
              },
            },
            '&.MuiPaginationItem-previousNext, &.MuiPaginationItem-firstLast': {
              fontSize: '1rem',
              minWidth: '40px',
              '&:hover': {
                backgroundColor: alpha(colors.primary[400], 0.2),
                transform: 'scale(1.05)',
              },
            },
            '&.Mui-disabled': {
              opacity: 0.4,
              color: colors.grey[500],
              borderColor: alpha(colors.grey[500], 0.3),
            },
          },
        }}
      />
    </Box>
  );
};

export default CustomPagination;
